import axios from '../utils/axiosInstance';

export const fetchSizeCompanyAPI = async () => axios.get('TamanoCompania/');






